<form [formGroup]="contactBanescoForm">
  <ng-container *ngIf='optionalFields'>
    <div class="mt-3 mb-4"
         i18n="@@contact-manager.banesco-form.beneficiaryInformation">
      Contact information
    </div>
  </ng-container>
  <fieldset class="bn-contact-manager-form__fieldset">
    <div class="row">
      <div class="bb-block col-12">
        <label i18n="@@contact-manager.banesco-form.productType">Product type</label>
        <bb-dropdown-single-select-ui [placeholder]="selectProductTypePlaceholder"
                                      formControlName="productType"
                                      displayAttributePath="desc"
                                      [options]="productTypes"
                                      (change)="enableAccountNumber()"
                                      class="d-block bb-block bb-block--lg">
        </bb-dropdown-single-select-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <label *ngIf="!customLabels?.accountNumber" i18n="@@contact-manager.banesco-form.accountNumber">Account number</label>
        <label *ngIf="customLabels?.accountNumber">{{customLabels.accountNumber}}</label>
        <input class="form-control"
               [disabled]="'disabled'"
               autocomplete="off"
               disabled
               formControlName="accountNumber"
               [mask]="accountNumberMask" />
        <bb-input-validation-message-ui role="alert"
                                        [showErrors]="contactBanescoForm.controls.accountNumber.invalid &&
              (contactBanescoForm.controls.accountNumber.dirty || contactBanescoForm.controls.accountNumber.touched)">
          <ng-container *ngIf="contactBanescoForm.controls.accountNumber.errors?.required">
            <span data-role="missing-account-name" i18n="@@contact-manager.other-form.accountNumberRequired">
              Account number is required
            </span>
          </ng-container>
          <ng-container *ngIf="contactBanescoForm.controls.accountNumber.errors?.accountNumberFormat">
            <span i18n="@@contact-manager.banesco-form.validation.format">
              Account number must only contain numbers
            </span>
          </ng-container>
          <ng-container *ngIf="contactBanescoForm.controls.accountNumber.errors?.account">
            <span i18n="@@contact-manager.banesco-form.validation.account">
              Account number must have a length of max 12 characters
            </span>
          </ng-container>
          <ng-container *ngIf="contactBanescoForm.controls.accountNumber.errors?.credit">
            <span i18n="@@contact-manager.banesco-form.validation.credit">
              Credit card number must have a length of max 16 characters
            </span>
          </ng-container>
          <ng-container *ngIf="contactBanescoForm.controls.accountNumber.errors?.invalidNumber">
            <span i18n="@@contact-manager.banesco-form.validation.invalid-account-number">
              You must validate the account number to continue
            </span>
          </ng-container>
        </bb-input-validation-message-ui>
      </div>
      <div class="bb-block col-12 mb-3">
        <div *ngIf="loadingValidation">
          <bb-loading-indicator-ui></bb-loading-indicator-ui>
        </div>
        <div *ngIf="!loadingValidation">
          <label i18n="@@contact-manager.banesco-form.beneficiary-name">Beneficiary Name</label>
          <input
            class="form-control"
            autocomplete="off"
            formControlName="name"
            [readOnly]="true"
          />
        </div>
      </div>
      <ng-container *ngIf="contactBanescoForm.get('productType')?.value?.id == '94'">
        <div class="bb-block col-12 mb-3">
          <label i18n="@@contact-manager.other-form.currency">Currency</label>
          <bb-dropdown-single-select-ui [placeholder]="selectCurrencyPlaceholder"
                                        [options]="currencies"
                                        displayAttributePath="desc"
                                        formControlName="currency"
                                        class="d-block bb-block bb-block--lg mb-0">
          </bb-dropdown-single-select-ui>

          <bb-input-validation-message-ui role="alert"
                                          [showErrors]="contactBanescoForm.controls.currency.invalid && (contactBanescoForm.controls.currency.dirty || contactBanescoForm.controls.currency.touched)">
            <ng-container *ngIf="contactBanescoForm.controls.productType.errors?.required">
              <span i18n="@@contact-manager.other-form.currencyRequired">
                Currency is required
              </span>
            </ng-container>
          </bb-input-validation-message-ui>
        </div>
      </ng-container>
      <ng-container *ngIf='optionalFields'>
        <div class="bb-block col-12 mb-3">
          <label i18n="@@contact-manager.banesco-form.alias">
            Alias (optional)
          </label>
          <bn-semaphore-tooltip class="ml-1"
                                [text]="infoTooltipText"
                                type="info"></bn-semaphore-tooltip>
          <bb-input-text-ui formControlName="alias"></bb-input-text-ui>
        </div>
        <div class="bb-block col-12 mb-3">
          <label i18n="@@contact-manager.banesco-form.email">
            Email (optional)
          </label>
          <bb-input-text-ui formControlName="email"></bb-input-text-ui>
        </div>
      </ng-container>
    </div>
  </fieldset>
</form>

<div style="display: none;">
  <div i18n="@@contact-manager.banesco-form.successMessage">Beneficiary created successfully</div>
  <div i18n="@@contact-manager.banesco-form.errorMessage">Something went wrong</div>
  <div i18n="@@contact-manager.banesco-form.infoLabel">A short or friendly way to call your beneficiary</div>
  <div i18n="@@contact-manager.banesco-form.selectProductType">Select a product type</div>
  <div i18n="@@contact-manager.banesco-form.errorMessageDuplicatedContact">Watch out, this name and account number are
    already registered in your beneficiary list. Try again.</div>
  <div i18n="@@contact-manager.banesco-form.idError">There was an error with the validation service</div>
</div>
